import { render, staticRenderFns } from "./RedeemCode.vue?vue&type=template&id=54aee70c&scoped=true&"
import script from "./RedeemCode.vue?vue&type=script&lang=js&"
export * from "./RedeemCode.vue?vue&type=script&lang=js&"
import style0 from "./RedeemCode.vue?vue&type=style&index=0&id=54aee70c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aee70c",
  null
  
)

export default component.exports